<template>
    <v-card elevation="0"  style="box-shadow: 0px">
        <v-card-title class="headline">Undo all changes?</v-card-title>
        <v-card-actions>
            <v-btn
              color="success"
              text
              @click="$emit('keep')"
              >
            Keep Editing
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="error"
              text
              @click="$emit('undo')"
              >
            Undo
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'UndoDialog'
}
</script>
